import { faFacebook, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Container } from "reactstrap";
import Typography from "src/components/Typography";
import classes from "./styles.module.scss";

const footerLinks = [
  {
    link: "/",
    label: "Home",
  },
  {
    link: "/order/create",
    label: "Order a Report",
  },
  {
    link: "/Sample-Shipping-Instructions.pdf",
    label: "Shipping Instructions",
  },
  {
    link: "/terms",
    label: "Terms & Conditions",
  },
];

const Footer = () => {
  return (
    <footer className={classes.footerWrapper}>
      <Container className={classes.container}>
        {footerLinks.map(({ label, link }, index) => {
          const isShippingInstructions = label === "Shipping Instructions";
          return (
            <a
              className={classes.links}
              key={index}
              href={link}
              {...(isShippingInstructions && {
                target: "_blank",
                rel: "noopener noreferrer",
              })}
            >
              {label}
            </a>
          );
        })}
        <div className={classes.socialLinks}>
          <a
            target="_blank"
            href="https://www.facebook.com/groups/namethatshinglerenamed"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faFacebook} />
          </a>
          <a
            target="_blank"
            href="https://www.youtube.com/channel/UCENVeMu0HnqPUBUoUYgkBpw"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faYoutube} />
          </a>
        </div>
      </Container>
      <Typography variant="p10" className={classes.copyRightText}>
        Copyright © 2022 UNIT 5 - All Rights Reserved.
      </Typography>
    </footer>
  );
};

export default Footer;
